import { extensionContainer } from '../../../../../../../common/container/ContainerContext';
import { injectEntityList } from '../../../../../../../common/store/base/injectEntityList';
import { injectPrimitive } from '../../../../../../../common/store/base/injectPrimitive';
import { IEntityListStore } from '../../../../../../../common/store/interface/IEntityListStore';
import { ISpecificationCategoryModel } from '../../../../../../../service/specification/category/ISpecificationCategoryModel';
import { ISpecificationEntityModel } from '../../../../../../../service/specification/entity/ISpecificationEntityModel';
import { ILocalization, ILocalizationToken } from '../../../../../../../application/language/ILocalization';
import { IUnitCardModel } from '../../interface/IUnitCardModel';
import { IGroupedUnitAdmin } from './IGroupedUnit';
import { IUnitListAdminPageUI } from './IUnitListAdminPageUI';

const createDefaultGroupedUnits = () => {
  const { translate }: ILocalization = extensionContainer.getByToken(ILocalizationToken);
  return injectEntityList([{ groupName: translate('learningAdminPage.withoutContext'), unitsList: [] }]);
};

export class UnitListAdminPageUI implements IUnitListAdminPageUI {
  constructor(
    public unitList = injectEntityList<IUnitCardModel>([]),
    public characteristic: IEntityListStore<ISpecificationEntityModel> = injectEntityList([]),
    public specificationCategory: IEntityListStore<ISpecificationCategoryModel> = injectEntityList([]),
    public isLoading = injectPrimitive<boolean>(false),
    public groupedUnits: IEntityListStore<IGroupedUnitAdmin> = createDefaultGroupedUnits(),
    public filtredGroupedUnits: IEntityListStore<IGroupedUnitAdmin> = injectEntityList([]),
    public searchText = injectPrimitive<string>(''),
  ) {}
}
